import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { Total } from '../../styles'
import { PaymentMethods } from './styles'

export default function Methods({ paymentMethods }) {
  const renderTotal = (paymentMethod) => (
    <Total>
      <div>{`${paymentMethod.method} ${paymentMethod.plan}`}</div>
      <div>{currencyFormat(paymentMethod.value)}</div>
    </Total>
  )

  return (
    <PaymentMethods>
      { paymentMethods.map(renderTotal) }
    </PaymentMethods>
  )
}

Methods.propTypes = {
  paymentMethods: PropTypes.arrayOf(PropTypes.object),
}

Methods.defaultProps = {
  paymentMethods: [],
}
